export default __webpack_public_path__ + "static/media/Mobi.bb4b7235.png";